var render, staticRenderFns
import script from "./buttonSelect.vue?vue&type=script&lang=js&"
export * from "./buttonSelect.vue?vue&type=script&lang=js&"
import style0 from "./buttonSelect.vue?vue&type=style&index=0&id=72f88e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f88e3c",
  null
  
)

export default component.exports